import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { toast } from "sonner";
import { initCapacitor } from "@/lib/capacitor-init";
import { installGlobalTapHaptics, installToastHaptics } from "@/lib/haptics";
import { initAmbientMusic } from "@/lib/ambient-music";

initCapacitor();
installGlobalTapHaptics();
installToastHaptics(toast);
initAmbientMusic();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
